import { OdinAccess } from "../../enums";
import accessMapping from './accessMapping.json';
import JWTHelper from "../jwt/JWTHelper";

class AccessHelper {
  async canBeAccessed(key: OdinAccess) {
    const role = await JWTHelper.getUserRole();
    const mapping = accessMapping[role];
    return mapping[key];
  }
}

export default new AccessHelper();
